import { render, staticRenderFns } from "./gameList.vue?vue&type=template&id=1be982c0&scoped=true&"
import script from "./gameList.vue?vue&type=script&lang=js&"
export * from "./gameList.vue?vue&type=script&lang=js&"
import style0 from "./gameList.vue?vue&type=style&index=0&id=1be982c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be982c0",
  null
  
)

export default component.exports